import PropTypes from 'prop-types'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

import { AlertMessage } from 'reactShared/components/AlertMessage'

import { formatPhone } from 'checkout/utils'

import { PICKUP_IN_STORE, READY_FOR_PICKUP } from '../../../consts'

const getCurrentStep = steps => steps.find(step => step.current)?.description

const LockerPinMessage = ({ type, pinCode, steps, phone }) => {
  const formattedPhone = formatPhone(phone)
  const isPickup = type === PICKUP_IN_STORE
  const currentStep = steps && getCurrentStep(steps)
  const isReadyForPickup = currentStep === READY_FOR_PICKUP
  const shouldShowMessage = isPickup && isReadyForPickup && Boolean(pinCode)

  return (
    shouldShowMessage && (
      <AlertMessage type="info">
        Seu pedido está separado em uma das gavetas do nosso Locker. Utilize seu
        telefone{' '}
        <Text as="strong" size="kilo" bold noMargin>
          {formattedPhone}{' '}
        </Text>
        e o código{' '}
        <Text as="strong" size="kilo" bold noMargin>
          {pinCode}{' '}
        </Text>
        para abrir a gaveta.
      </AlertMessage>
    )
  )
}

LockerPinMessage.propTypes = {
  type: PropTypes.string.isRequired,
  pinCode: PropTypes.string,
  steps: PropTypes.array,
  phone: PropTypes.string
}

export default LockerPinMessage
